import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { RateAdminBreadcrumb } from "../RateAdminRateCode/CreateRateAdminRateCode/constant";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const RateAdminBlackouts = (props) => {
  const classes = useStyles();
  const {
    fetchRateAdminBlackoutss,
    tableData,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    exportRateAdminBlackouts,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateRateAdminBlackouts,
    editRateAdminBlackoutsRoute,
    savedTableState,
    onTableStateChange,
    deleteRateAdminBlackouts,
    isRateAdminBlackoutsDeleteSuccess,
    isRateAdminBlackoutsDeleteError,
  } = props;

  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const convertToTSV = (data) => {
    // Get headers from columns (including ID)
    const headers = data.columns.map((item) => item.colLabel).join("\t");

    // Get rows with values in the same order as columns
    const rows = data.rows
      .map((row) => {
        return data.columns
          .map((col) => {
            const value = row[col.dataKey];
            // Handle null/undefined values
            if (value === null || value === undefined) {
              return "-";
            }
            // Convert to string
            return String(value);
          })
          .join("\t");
      })
      .join("\n");

    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  const handlePrint = () => {
    const success = printTableData({
      title: "Blackouts",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
    });
    if (!success) {
      setIsPrintError(true);
    }
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Blackouts</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>

          <div className="buttonarea">
            {screenPermissions?.create && (
              <div className="create-btn-group">
                <Button
                  label={"Create Blackouts"}
                  className={`p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateRateAdminBlackouts}
                />
              </div>
            )}
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={`p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={`p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportRateAdminBlackouts}
              />
              <Button
                label={"Print"}
                className={`p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();

  // Build initial filters from saved state if available
  const getInitialFilters = () => {
    const defaultFilters = {
      global: { value: null },
      locationTitles: { value: null, filterKey: "locationTitles" },
      categoryCodes: { value: null, filterKey: "categoryCodes" },
      groupTitles: { value: null, filterKey: "groupTitles" },
      startDate: { value: null, filterKey: "startDate" },
      startTime: { value: null, filterKey: "startTime" },
      endDate: { value: null, filterKey: "endDate" },
      endTime: { value: null, filterKey: "endTime" },
      pickupAllowed: { value: null, filterKey: "pickupAllowed" },
      spanoverAllowed: { value: null, filterKey: "spanoverAllowed" },
      blackoutMessage: { value: null, filterKey: "blackoutMessage" },
      crtBy: { value: null, filterKey: "crtBy" },
      crtTime: { value: null, filterKey: "crtTime" },
      modBy: { value: null, filterKey: "modBy" },
      modTime: { value: null, filterKey: "modTime" },
      status: { value: null, filterKey: "status" },
    };

    // If we have saved filters, merge them with defaults
    if (savedTableState?.filters) {
      const savedFilters = savedTableState.filters;
      Object.keys(savedFilters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedFilters[key] };
        }
      });
    }

    return defaultFilters;
  };

  const filters = getInitialFilters();

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
    if (isRateAdminBlackoutsDeleteSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Blackout deleted successfully!",
        shouldShowToast: true,
      };
    }
    if (isRateAdminBlackoutsDeleteError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while deleting blackout!",
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Blackouts found.",
    filters,
    loadLazyData: fetchRateAdminBlackoutss,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || 'id',
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    onEditRecord: editRateAdminBlackoutsRoute,
    onDeleteRecord: deleteRateAdminBlackouts,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: true,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={RateAdminBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box>
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Blackouts records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default RateAdminBlackouts;
